import React, {useEffect, useState} from "react";
import ModalNeedApprovedLegalEntity from "../modals/need-approved-legal-entity";
import ModalCreateOrder from "../modals/create-order-delivery";
import {deliveriesService, orderDeliveryService, userServices} from "../../services";
import {Button, notification, Popconfirm, Upload} from "antd";
import {ShortDate} from "./delivery-tools";
import ModalAttachDriverOrderDelivery from "../modals/attach-driver-order-delivery";
import ModalEdoSend from "../modals/edo-send";
import moment from "moment";
import {
  DELIVERY_AWAITING_LOADING,
  DELIVERY_BOOKED,
  DELIVERY_ENROUTE,
  DELIVERY_ORDER_FILLED,
  DELIVERY_LOADING, DELIVERY_AGREED, DELIVERY_ORDER_AWAITING_AGREED, DELIVERY_ORDER_APPROVED, DELIVERY_ORDER_AGREED,
  DELIVERY_IN_TENDER,
  DELIVERY_OFFER_AGREED
} from "../../helpers/delivery_status.helper";
import {DELIVERY_DEFAULT_TYPE, offerTitle} from "../../helpers/delivery.helper";
import ModalChooseLoadingGate from "../modals/choose-time-loading";
import ModalShowOrderDocs from "../modals/order-docs";
import ModalChangeLoadingDate from "../modals/change-loading-date";
import ModalReturnToEnRoute from "../modals/return-to-en-route";
import ModalReturnLoadingDelivery from "../modals/return-loading-delivery";
import ModalRequestAllowInternational from "../modals/request-allow-international";
import ModalCreateOffer from "../modals/create-delivery-offer";
import i18n from "../../i18n";


export function CarrierHeaderButton({
                                      delivery,
                                      permissions,
                                      setNeedUpdate,
                                      setStopListUpdate,
                                      setLoadingDelivItem,
                                      timerEnabled
                                    }) {
  const user = userServices.getUser();

  // if(user.info.userType != "carrier") {
  //     return null;
  // }
  //
  if (typeof (delivery.Permissions) == "undefined") {
    return null;
  }
  if (delivery.Permissions.IsAvailableManageDelivery === true) {
    return null;
  }
  const [isModalLoadingSignUpShow, setIsModalLoadingSignUpShow] = useState(null);
  const [isModalReturnToEnRouteShow, setIsModalReturnToEnRouteShow] = useState(null);
  const [isModalReturnLoadingShow, setIsModalReturnLoadingShow] = useState(null);
  const [isModalOrderDocsShow, setIsModalOrderDocsShow] = useState(null);
  const [showChangeLoadingDateModal, setShowChangeLoadingDateModal] = useState(false);

  const onClickLoadingSingOut = () => {
    deliveriesService.cancelLoadingSignUp(delivery.Id)
      .then((response) => {
        if (response.code === 400) {
          notification.error({
            message: i18n.t('components.notification.titles.cancelLoadingSignUp.errors'),
            description: response.message,
          });
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.cancelLoadingSignUp.success'),
            description: response.message,
          });
          setNeedUpdate(true);
        }
      })
      .catch((errMsg) => notification.error(
        {
          message: i18n.t('components.notification.titles.cancelLoadingSignUp.errors'),
          description: errMsg
        }));
  }

  const onClickEnRouteDelivery = (e) => {
      e.preventDefault();
      setLoadingDelivItem(true);

      deliveriesService
          .enRoute(delivery.Id)
          .then((response) => {
              notification.success({
                  message: i18n.t('components.notification.titles.enRoute'),
                  description: response.message,
              });

              setLoadingDelivItem(false);
              setNeedUpdate(true);
          })
          .catch((error) => {
              notification.error({
                  message: i18n.t('components.notification.titles.enRoute'),
                  description: error,
              });

              setLoadingDelivItem(false);
              setNeedUpdate(true);
          });
  };

  const onClickRefuseOffer = (deliveryId, id) => {
    setLoadingDelivItem(true);
    deliveriesService
      .refuseOffer(deliveryId, id)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.refuseOffer'),
          description: response.message,
        });
        setLoadingDelivItem(false);
        setNeedUpdate(true);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.refuseOffer'),
          description: error,
        });
        setNeedUpdate(true);
      });
  }

  const onClickCreateOrderFromOffer = (deliveryId, id) => {
    setLoadingDelivItem(true);
    orderDeliveryService
      .createOrderFromOffer(deliveryId, id)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.createOrderFromOffer'),
          description: response.message,
        });
        setLoadingDelivItem(false);
        setNeedUpdate(true);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.createOrderFromOffer'),
          description: error,
        });
        setNeedUpdate(true);
      });
  }

  const [showModalCreateOffer, setShowModalCreateOffer] = useState(false);

  if (delivery.Status === DELIVERY_AWAITING_LOADING || delivery.Status === DELIVERY_ENROUTE || delivery.Status === DELIVERY_LOADING || delivery.Status === DELIVERY_AGREED) {
    let buttons = [];

    if (delivery.Status === DELIVERY_ENROUTE) {
      buttons.push((
        <React.Fragment key={`return-loading-button-${delivery.Id}`}>
          <button
            className="action-button"
            onClick={() => {
              setIsModalReturnLoadingShow(delivery.Id);
            }}
          >{i18n.t('components.tools.carrierHeaderButton.buttons.returnToLoading')}
          </button>
          <ModalReturnLoadingDelivery
            onCloseModal={() => {
              setIsModalReturnLoadingShow(null);
            }}
            isShow={isModalReturnLoadingShow === delivery.Id}
            id={delivery.Id}/>
        </React.Fragment>
      ));
    }

    if (delivery.Status === DELIVERY_LOADING || delivery.Status === DELIVERY_AWAITING_LOADING) {
      if (delivery.IsMultimodal) {
        buttons.push (
            <Popconfirm
              title={i18n.t('main.confirm.questions')}
              okText={i18n.t('main.confirm.answer.yes')}
              cancelText={i18n.t('main.confirm.answer.no')}
                onConfirm={onClickEnRouteDelivery}
            >
                <a className="action-button typical-btn-blue">
                  {i18n.t('components.tools.logistShortButton.buttons.enRoute')}
                </a>
            </Popconfirm>
        );
      }

      if (delivery.Order.Docs.Procuration) {
        const procurationFile = delivery.Order.Docs.Procuration.File ? delivery.Order.Docs.Procuration.File : delivery.Order.Docs.Procuration.Blank;

        const onClickDownloadProcurationBlank = (url) => {
          window.open(url);
        };

        buttons.push((
          <button
            className={`action-button`}
            // style={{ fontSize: "11px" }}
            onClick={() => onClickDownloadProcurationBlank(procurationFile)}
          >
            {i18n.t('components.tools.carrierHeaderButton.buttons.downloadProcuration')}
          </button>
        ));
      }

      if (delivery.Order.Docs.Agreement) {
        const agreementFile = delivery.Order.Docs.Agreement.File ? delivery.Order.Docs.Agreement.File : delivery.Order.Docs.Agreement.Template;

        const onClickDownloadAgreementBlank = (url) => {
          window.open(url);
        };

        if (agreementFile) {
          buttons.push((
            <button
              className={`action-button`}
              // style={{ fontSize: "11px" }}
              onClick={() => onClickDownloadAgreementBlank(agreementFile)}
            >
              {i18n.t('components.tools.carrierHeaderButton.buttons.downloadAgreement')}
            </button>
          ));
        }
      }

      if (delivery.Permissions.IsCanSignUpForLoading && delivery.LoadingSign === null && !delivery.IsMultimodal) {

        buttons.push((
          <>
            <button
              className={`action-button`}
              onClick={() => {
                setIsModalLoadingSignUpShow(delivery.Id);
              }}
            >
              {i18n.t('components.tools.carrierHeaderButton.buttons.loadingSignUp')}
            </button>
            <ModalChooseLoadingGate
              id={delivery.Id}
              isShow={isModalLoadingSignUpShow === delivery.Id}
              onCloseModal={() => {
                setIsModalLoadingSignUpShow(null);
              }}
              setNeedUpdate={setNeedUpdate}
              date={delivery.Order.Date}
            />
          </>
        ));
      }

      if (delivery.LoadingSign !== null && delivery.Permissions.IsCanSignUpForLoading) {//TODO проверить переводы!!
        buttons.push((
          <Popconfirm
            title={i18n.t('components.tools.carrierHeaderButton.confirm.cancel')}
            okText={i18n.t('main.confirm.answer.yes')}
            cancelText={i18n.t('main.confirm.answer.no')}
            onConfirm={() => onClickLoadingSingOut()}
          >
            <button
              className={`action-button typical-btn-red`}
            >
              {i18n.t('components.tools.carrierHeaderButton.buttons.loadingSingOut')} {delivery.LoadingSign.DateTime.split(' ')[1]}
            </button>
          </Popconfirm>
        ));
      }
    }

    if (delivery.Status === DELIVERY_AGREED) {
      if (delivery.ExternalDateCreated) {
        buttons.push(
          <React.Fragment key={`invoice-button-${delivery.Id}`}>
            <button
              className="action-button"
              onClick={() => {
                setIsModalOrderDocsShow(delivery.Id);
              }}
            >{i18n.t('components.tools.carrierHeaderButton.buttons.orderDocs')}
            </button>
            <button
              className="action-button"
              onClick={() => {
                setIsModalReturnToEnRouteShow(delivery.Id);
              }}
            >{i18n.t('components.tools.carrierHeaderButton.buttons.returnToEnRoute')}
            </button>
            <ModalShowOrderDocs
              isShow={isModalOrderDocsShow === delivery.Id}
              onCloseModal={() => {
                setIsModalOrderDocsShow(null);
              }}
              invoice={delivery.Order.Docs.Invoce || null}
              act={delivery.Order.Docs.Act || null}
              number={delivery.NumberDelivery}
              id={delivery.Id}
            />
            <ModalReturnToEnRoute
              onCloseModal={() => {
                setIsModalReturnToEnRouteShow(null);
              }}
              isShow={isModalReturnToEnRouteShow === delivery.Id}
              id={delivery.Id}/>
          </React.Fragment>
        );
      }
    }

    if (delivery.Status === DELIVERY_LOADING || delivery.Status === DELIVERY_AWAITING_LOADING) {
      buttons.push(
        <>
          <button
            className={`action-button typical-btn-red`}
            onClick={() => setShowChangeLoadingDateModal(true)}
          >
            {i18n.t('components.tools.carrierHeaderButton.buttons.changeLoadingDate')}
          </button>
          <ModalChangeLoadingDate
            id={delivery.Order.Id} isShow={showChangeLoadingDateModal}
            onCloseModal={setShowChangeLoadingDateModal}
            date={delivery.LoadingSign ? delivery.LoadingSign.DateTime : moment(delivery.Order.Date).format('DD.MM.YYYY')}/>
        </>
      )
    }
    return buttons;
  }

  if (delivery.Status === DELIVERY_IN_TENDER && delivery.Offers && delivery.Offers.length > 0) {
    let buttons = [];
    delivery.Offers.forEach((item) => {
      buttons.push(
        <div className="offer-data">
          {i18n.t('components.tools.carrierHeaderButton.text.1', {status: offerTitle[item.Status]})}
          <p dangerouslySetInnerHTML={{
            __html: i18n.t(
              'components.tools.carrierHeaderButton.text.2',
              {
                sum: `${item.Sum.toLocaleString("ru")} ${item.PaymentSymbol}`,
                date: moment(item.DateLoading).format("DD.MM.YYYY")
              }
            )
          }}/>
        </div>);
      if (item.Status === DELIVERY_OFFER_AGREED) {
        buttons.push(
          <div>
            <Popconfirm
              title={i18n.t('main.confirm.questions')}
              okText={i18n.t('main.confirm.answer.yes')}
              cancelText={i18n.t('main.confirm.answer.no')}
              onConfirm={() => onClickCreateOrderFromOffer(delivery.Id, item.Id)}
            >
              <a className="action-button typical-btn-green">
                {i18n.t('components.tools.carrierHeaderButton.buttons.createOrderFromOffer')}
              </a>
            </Popconfirm>
          </div>
        );
      }
      buttons.push(
        <div>
          <Popconfirm
            title={i18n.t('main.confirm.questions')}
            okText={i18n.t('main.confirm.answer.yes')}
            cancelText={i18n.t('main.confirm.answer.no')}
            onConfirm={() => onClickRefuseOffer(delivery.Id, item.Id)}
          >
            <a className="action-button typical-btn-red">
              {i18n.t('components.tools.carrierHeaderButton.buttons.refuseOffer')}
            </a>
          </Popconfirm>
        </div>
      );
    });

    if(delivery.IsMultimodal) {
      buttons.push(
        <div>
          <a
            className="action-button typical-btn-blue"
            disabled={!delivery.Tender.IsActive}  //TODO disabled не работает на ссылке (а у меня работает)
            onClick={() => {
              setStopListUpdate(true);
              setShowModalCreateOffer(true);
            }}
          >
            <span className="speedometer">
              {i18n.t('components.tools.carrierHeaderButton.buttons.createOffer')}
            </span>
          </a>
          <ModalCreateOffer
            isShow={showModalCreateOffer}
            setIsShow={setShowModalCreateOffer}
            delivery={delivery}
            setNeedUpdateDeliveryList={setNeedUpdate}
            setStopListUpdate={setStopListUpdate}
            paymentType={paymentType}
            setPaymentType={setPaymentType}
          />
        </div>
      );
    }

    return buttons;
  }

  const [showModalAttachDriver, setShowModalAttachDriver] = useState(false);
  const [showModalCreateOrder, setShowModalCreateOrder] = useState(false);
  const [paymentType, setPaymentType] = useState(null);

  useEffect(() => {
    const price = delivery.Prices.find(e => e.Price !== null);
    if (price) {
      setPaymentType(price.PaymentType.Id);
    }
  }, [delivery]);

  const isForeignDelivery = delivery.IsForeignDelivery;

  const nameRegionLastPointUnload = delivery.PlacesUnload.length
    ? delivery.PlacesUnload[delivery.PlacesUnload.length - 1].City
    : "-";

  const regionLoad = delivery.PlaceLoad.City ? delivery.PlaceLoad.City : "-";

  const onClickShowModalAttachDriver = (e) => {
    e.preventDefault();

    setStopListUpdate(true);
    setShowModalAttachDriver(true);
  };

  const onClickRefuseOrder = (e) => {
    e.preventDefault();
    setLoadingDelivItem(true);

    orderDeliveryService
      .refuseOrder(delivery.Order.Id)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.refuseOrderToConsignor'),
          description: response.message,
        });
        setLoadingDelivItem(false);
        setNeedUpdate(true);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.refuseOrderToConsignor'),
          description: error,
        });
        setNeedUpdate(true);
      });
  };

  const onClickRefuseCounteroffer = (e) => {
    e.preventDefault();
    setLoadingDelivItem(true);

    orderDeliveryService
      .refuseCounteroffer(delivery.Order.Id)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.refuseCounteroffer'),
          description: response.message,
        });
        setLoadingDelivItem(false);
        setNeedUpdate(true);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.refuseCounteroffer'),
          description: error,
        });
        setNeedUpdate(true);
      });
  };

  const onClickAgreeCounteroffer = (e) => {
    e.preventDefault();
    setLoadingDelivItem(true);

    orderDeliveryService
      .agreeCounteroffer(delivery.Order.Id)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.agreeCounteroffer'),
          description: response.message,
        });
        setLoadingDelivItem(false);
        setNeedUpdate(true);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.agreeCounteroffer'),
          description: error,
        });
        setNeedUpdate(true);
      });
  };

  let btnFillOrder;
  if (delivery.Status === DELIVERY_BOOKED) {
    btnFillOrder = (
      <a
        href="#"
        className="action-button"
        onClick={onClickShowModalAttachDriver}
      >
        <span className="speedometer">{i18n.t('components.tools.carrierHeaderButton.buttons.attachDriver')}</span>
      </a>
    );
  }

  if (delivery.Order) {
    let buttonsLoadingSign = [];
    let buttonsChangeDate = [];
    if (delivery.LoadingSign && delivery.Permissions.IsCanSignUpForLoading) {
      buttonsLoadingSign.push((
        <>
          <Popconfirm
            title={i18n.t('components.tools.carrierHeaderButton.confirm.cancel')}
            okText={i18n.t('main.confirm.answer.yes')}
            cancelText={i18n.t('main.confirm.answer.no')}
            onConfirm={() => onClickLoadingSingOut()}
          >
            <button
              className={`action-button typical-btn-red`}
            >
              {i18n.t('components.tools.carrierHeaderButton.buttons.loadingSingOut', {date: delivery.LoadingSign.DateTime.split(' ')[1]})}
            </button>
          </Popconfirm>
        </>
      ));
    }
    if (delivery.LoadingSign === null && delivery.Permissions.IsCanSignUpForLoading && !delivery.IsMultimodal) {
      buttonsLoadingSign.push((
        <>
          <button
            style={{marginTop: "5px"}}
            className={`action-button`}
            onClick={() => {
              setIsModalLoadingSignUpShow(delivery.Id);
            }}
          >
            {i18n.t('components.tools.carrierHeaderButton.buttons.loadingSignUp')}
          </button>
          <ModalChooseLoadingGate
            id={delivery.Id}
            isShow={isModalLoadingSignUpShow === delivery.Id}
            onCloseModal={() => {
              setIsModalLoadingSignUpShow(null);
            }}
            setNeedUpdate={setNeedUpdate}
            date={delivery.Order.Date}
          />
        </>
      ))
    }
    if (delivery.Order.Status === DELIVERY_ORDER_APPROVED || delivery.Order.Status === DELIVERY_ORDER_FILLED || delivery.Order.Status === DELIVERY_ORDER_AGREED) {
      buttonsChangeDate.push(
        <>
          <button className={`action-button typical-btn-red`} onClick={() => setShowChangeLoadingDateModal(true)}
          >
            {i18n.t('components.tools.carrierHeaderButton.buttons.changeLoadingDate')}
          </button>
          <ModalChangeLoadingDate
            id={delivery.Order.Id} isShow={showChangeLoadingDateModal}
            onCloseModal={setShowChangeLoadingDateModal}
            date={delivery.LoadingSign ? delivery.LoadingSign.DateTime : moment(delivery.Order.Date).format('DD.MM.YYYY')}/>
        </>
      )
    }
    if (delivery.Order.Status === DELIVERY_ORDER_FILLED) {
      return (
        <>
          <UploadDocsButtons
            delivery={delivery}
            setLoadingDelivItem={setLoadingDelivItem}
            setNeedUpdate={setNeedUpdate}
            setStopListUpdate={setStopListUpdate}
          />
          {buttonsLoadingSign}
          {buttonsChangeDate}
        </>
      );
    } else if (delivery.Order.Counteroffer) {
      return (
        <div>
          <div className="offer-data" dangerouslySetInnerHTML={{
            __html: i18n.t(
              'components.tools.carrierHeaderButton.text.3',
              {
                sum: `${delivery.Order.Counteroffer.Price.toLocaleString("ru")}  ${delivery.Order.PaymentSymbol}`,
                date: moment(delivery.Order.Counteroffer.DateLoading).format("DD.MM.YYYY")
              }
            )
          }}
          />
          <a onClick={onClickAgreeCounteroffer}
             href="#"
             className="action-button counter-offer-accept">{i18n.t('main.buttons.agree')}</a>
          <a onClick={onClickRefuseCounteroffer}
             href="#"
             className="action-button counter-offer-decline">{i18n.t('main.buttons.decline')}</a>
        </div>
      );
    } else if (delivery.Order.Status === DELIVERY_ORDER_AWAITING_AGREED) {
      return (
        <>
          {buttonsLoadingSign}
        </>
      );
    } else {
      const dateShipmentRus = moment(delivery.Order.Date).format("D MMMM YYYY");

      return (
        <div>
          <div className="offer-data">
            Заявка: {delivery.Order.Price.toLocaleString("ru")} {delivery.Order.PaymentSymbol} на <u><ShortDate
            date={delivery.Order.Date}/></u>
          </div>
          {btnFillOrder}
          <Popconfirm
            title={i18n.t('main.confirm.questions')}
            okText={i18n.t('main.confirm.answer.yes')}
            cancelText={i18n.t('main.confirm.answer.no')}
            onConfirm={onClickRefuseOrder}
          >
            <a className="action-button typical-btn-red">
              {i18n.t('components.tools.carrierHeaderButton.buttons.refuseOrder')}

            </a>
          </Popconfirm>
          <ModalAttachDriverOrderDelivery
            key={`modal_${delivery.Id}`}
            isShow={showModalAttachDriver}
            setIsShow={setShowModalAttachDriver}
            orderId={delivery.Order.Id}
            companyId={delivery.Order.Company.Id}
            setStopListUpdate={setStopListUpdate}
            setNeedUpdateDeliveryList={setNeedUpdate}
            deliveryDateShipmentRus={dateShipmentRus}
            deliveryPrice={delivery.Order.Price}
            deliveryRegionLoad={regionLoad}
            deliveryRegionUnload={nameRegionLastPointUnload}
            isForeignDelivery={isForeignDelivery}
            deliveryContractType={delivery.ContractType}
            deliveryId={delivery.Id}
            date={delivery.Order.Date}
            permissions={delivery.Permissions}
            delivery={delivery}
          />
          {buttonsChangeDate}
        </div>
      );
    }
  } else {
    if (typeof (permissions.IsCanCreateOrder) !== "undefined" && permissions.IsCanCreateOrder === false) {
      return (
        <div>
          <a
            className="action-button"
            onClick={() => {
              setStopListUpdate(true);
              setShowModalCreateOrder(true);
            }}
          >
            <span className="speedometer">
              {i18n.t('components.tools.carrierHeaderButton.buttons.createOrder')}
            </span>
          </a>
          <ModalNeedApprovedLegalEntity
            isShow={showModalCreateOrder}
            setIsShow={setShowModalCreateOrder}
            text={i18n.t('modals.modalNeedApprovedLegalEntity.text.legalEntity')}
            title={i18n.t('modals.modalNeedApprovedLegalEntity.titles.custom')}
          />
        </div>
      );
    }
    if (delivery.IsForeignDelivery && !(delivery.Permissions && delivery.Permissions.isAccreditationInternationalDeliveries === true)) {
      return (
        <div>
          <a
            className="action-button"
            onClick={() => {
              setStopListUpdate(true);
              setShowModalCreateOrder(true);
            }}
          >
            <span className="speedometer">
              {i18n.t('components.tools.carrierHeaderButton.buttons.createOrder')}
            </span>
          </a>
          <ModalRequestAllowInternational
            isShow={showModalCreateOrder}
            setIsShow={setShowModalCreateOrder}
            delivery={delivery}
            setNeedUpdateDeliveryList={setNeedUpdate}
            setStopListUpdate={setStopListUpdate}
          />
        </div>
      );
    }
    if(delivery.Status === DELIVERY_IN_TENDER) {
      return (
        <div>
          <a
            className="action-button typical-btn-blue"
            disabled={!delivery.Tender.IsActive}  //TODO disabled не работает на ссылке (а у меня работает)
            onClick={() => {
              setStopListUpdate(true);
              setShowModalCreateOffer(true);
            }}
          >
            <span className="speedometer">
              {i18n.t('components.tools.carrierHeaderButton.buttons.createOffer')}
            </span>
          </a>
          <ModalCreateOffer
            isShow={showModalCreateOffer}
            setIsShow={setShowModalCreateOffer}
            delivery={delivery}
            setNeedUpdateDeliveryList={setNeedUpdate}
            setStopListUpdate={setStopListUpdate}
            paymentType={paymentType}
            setPaymentType={setPaymentType}
          />
        </div>
      );
    }
    if (!timerEnabled) {
      return (
        <div>
          <a
            className="action-button"
            onClick={() => {
              setStopListUpdate(true);
              setShowModalCreateOrder(true);
            }}
          >
            <span className="speedometer">
              {i18n.t('components.tools.carrierHeaderButton.buttons.createOrder')}
            </span>
          </a>
          <ModalCreateOrder
            isShow={showModalCreateOrder}
            setIsShow={setShowModalCreateOrder}
            delivery={delivery}
            setNeedUpdateDeliveryList={setNeedUpdate}
            setStopListUpdate={setStopListUpdate}
            paymentType={paymentType}
            setPaymentType={setPaymentType}
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

function UploadDocsButtons({delivery, setLoadingDelivItem, setNeedUpdate, setStopListUpdate}) {
  const [scanAgreement, setScanAgreement] = useState(null);
  const [scanProcuration, setScanProcuration] = useState(null);
  const [loading, setLoading] = useState(false);

  const [showEdoModal, setShowEdoModal] = useState(false);
  const [currentLegalEntityId, setCurrentLegalEntityId] = useState(false);
  const [currentType, setCurrentType] = useState(null);

  const templateAgreement = delivery.Order.Docs.Agreement.Template;
  const isDisabledUpload = templateAgreement === null;

  const onClickDownloadTemplateAgreement = () => {
    if (!isDisabledUpload) {
      window.open(delivery.Order.Docs.Agreement.Template);
    }
  };

  const onClickDownloadProcurationBlank = () => {
    window.open(delivery.Order.Docs.Procuration.Blank);
  };

  const handleShowSend = (id, type) => {
    setCurrentLegalEntityId(id);
    setCurrentType(type);
    setShowEdoModal(true);
  };

  const uploadPropsAgreement = {
    multiple: false,
    disabled: isDisabledUpload || scanAgreement !== null,
    showUploadList: false,
    onRemove: () => {
      setScanAgreement(null);
    },
    beforeUpload: (file) => {
      setStopListUpdate(true);
      setScanAgreement(file);
      return false;
    },
  };
  const uploadPropsProcuration = {
    multiple: false,
    disabled: isDisabledUpload || scanProcuration !== null,
    showUploadList: false,
    onRemove: () => {
      setScanProcuration(null);
    },
    beforeUpload: (file) => {
      setStopListUpdate(true);
      setScanProcuration(file);
      return false;
    },
  };

  const needScanProcuration = delivery.Order.Docs.Procuration !== null;

  if (((needScanProcuration && scanAgreement !== null && scanProcuration !== null) || (!needScanProcuration && scanAgreement !== null)) && !loading) {
    setLoading(true);
    setLoadingDelivItem(true);

    orderDeliveryService.agreeWithDocs(delivery.Order.Id, scanAgreement, scanProcuration)
      .then((response) => {
        setScanAgreement(null);
        setScanProcuration(null);

        setLoading(false);
        setLoadingDelivItem(false);
        setStopListUpdate(false);

        if (response.status === "success") {
          setNeedUpdate(true);
          notification.success({
            message: i18n.t('components.notification.titles.agreeWithDocs'),
            description: response.message,
          });
        } else if (response.status === "error") {
          for (let fieldName in response.errors) {
            if (response.errors.hasOwnProperty(fieldName)) {
              const errorMsg = response.errors[fieldName][0];
              notification.error({
                message: i18n.t('components.notification.titles.agreeWithDocs'),
                description: errorMsg,
              });
            }
          }
        }
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.agreeWithDocs'),
          description: error,
        });

        setScanAgreement(null);
        setScanProcuration(null);

        setLoading(false);
        setLoadingDelivItem(false);
        setStopListUpdate(false);
      });
  }

  const buttonExtClassName = isDisabledUpload ? "disabled" : "";
  const buttonAgreementColorClassName = scanAgreement === null ? "typical-btn-blue" : "typical-btn-green";
  const buttonProcurationColorClassName = scanProcuration === null ? "typical-btn-blue" : "typical-btn-green";

  if (needScanProcuration) {
    return (
      <div>
        <button
          className={`action-button ${buttonExtClassName}`}
          // style={{ fontSize: "11px" }}
          onClick={onClickDownloadTemplateAgreement}
        >
          {i18n.t('components.tools.uploadDocsButtons.buttons.downloadTemplateAgreement')}
        </button>
        <Button className={`action-button ${buttonAgreementColorClassName} ${buttonExtClassName}`} 
          onClick={() => handleShowSend(delivery.Order.LegalEntity.Id, 'agreement')}
          disabled={uploadPropsAgreement.disabled}
        >
            <small>Отправить заявку в ЭДО</small>
        </Button>
        <Upload {...uploadPropsAgreement}>
          <Button
            className={`action-button ${buttonAgreementColorClassName} ${buttonExtClassName}`}
            // style={{ marginBottom: '5px' }}
            htmlType="button"
          >
            {i18n.t('components.tools.uploadDocsButtons.buttons.uploadAgreement')}
          </Button>
        </Upload>

        <br/>

        {delivery.Order.Docs.Procuration.Blank &&
          (<><button
            className={`action-button`}
            // style={{ fontSize: "11px" }}
            onClick={onClickDownloadProcurationBlank}
          >
            {i18n.t('components.tools.uploadDocsButtons.buttons.downloadProcurationBlank')}
          </button>
          <Button className={`action-button ${buttonProcurationColorClassName} ${buttonExtClassName}`} 
            onClick={() => handleShowSend(delivery.Order.LegalEntity.Id, 'procuration')}
            disabled={uploadPropsProcuration.disabled}
          >
              <small>Отправить доверенность в ЭДО</small>
          </Button></>
          )
        }
        <Upload {...uploadPropsProcuration}>
          <Button
            className={`action-button ${buttonProcurationColorClassName} ${buttonExtClassName}`}
            // style={{ fontSize: "11px", padding: 0 }}
            htmlType="button"
          >
            {i18n.t('components.tools.uploadDocsButtons.buttons.uploadProcuration')}
          </Button>
        </Upload>
        <ModalEdoSend legalEntityId={currentLegalEntityId} isShow={showEdoModal} setIsShow={setShowEdoModal} type={currentType} orderId={delivery.Order.Id}/>
      </div>
      
    );
  } else {
    return (
      <div>
        <button className={`action-button ${buttonExtClassName}`} onClick={onClickDownloadTemplateAgreement}>
          {i18n.t('components.tools.uploadDocsButtons.buttons.downloadTemplateAgreement')}
        </button>
        <Button className={`action-button ${buttonAgreementColorClassName} ${buttonExtClassName}`} 
          onClick={() => handleShowSend(delivery.Order.LegalEntity.Id, 'agreement')}
          disabled={uploadPropsAgreement.disabled}
        >
            <small>Отправить заявку в ЭДО</small>
        </Button>
        <Upload className={`action-button-upload`}{...uploadPropsAgreement}>
          <Button className={`${buttonAgreementColorClassName} ${buttonExtClassName}`} htmlType="button">
            {i18n.t('components.tools.uploadDocsButtons.buttons.uploadAgreement')}
          </Button>
        </Upload>
        <ModalEdoSend legalEntityId={currentLegalEntityId} isShow={showEdoModal} setIsShow={setShowEdoModal} type={currentType} orderId={delivery.Order.Id}/>
      </div>
    );
  }
}
